module.exports = __webpack_public_path__ + "shopping.2f3ef04e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/eco-token/shopping.svg
// module id = 2609
// module chunks = 0